import { http } from '@/core/api/';

export const getAmendmentHistory = async (requestId) =>
  await http.get(`api/taprequests/amendment/history/${requestId}`);
